import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Paper } from "@mui/material";
import { APP_COLORS } from "../../theme/appTheme";

export const DashboardStatsCard = ({
    title,
    value,
    icon: Icon,
    color,
    subtitle,
    onClick
}) => {
    const cardColor = color || APP_COLORS.primary.main;

    return (
        <Paper
            elevation={0}
            onClick={onClick}
            sx={{
                p: { xs: 2, md: 2.5 },
                borderRadius: 3,
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'background.paper',
                cursor: onClick ? 'pointer' : 'default',
                transition: 'all 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)',
                '&:hover': onClick ? {
                    transform: 'translateY(-2px)',
                    boxShadow: APP_COLORS.elevation.md,
                    borderColor: cardColor
                } : {},
                minHeight: { xs: 150, md: 120 },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                <Box>
                    <Typography
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                            fontWeight: 500,
                            mb: 0.5
                        }}
                    >
                        {title}
                    </Typography>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: 700,
                            color: 'text.primary',
                            lineHeight: 1.2
                        }}
                    >
                        {typeof value === 'number' ? value.toLocaleString('pt-BR') : value}
                    </Typography>
                </Box>
                {Icon && (
                    <Box
                        sx={{
                            width: { xs: 44, md: 48 },
                            height: { xs: 44, md: 48 },
                            borderRadius: 2,
                            backgroundColor: `${cardColor}15`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Icon sx={{ fontSize: 24, color: cardColor }} />
                    </Box>
                )}
            </Box>
            {subtitle && (
                <Typography
                    variant="caption"
                    sx={{
                        color: 'text.secondary',
                        mt: 1
                    }}
                >
                    {subtitle}
                </Typography>
            )}
        </Paper>
    );
};

DashboardStatsCard.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    icon: PropTypes.elementType,
    color: PropTypes.string,
    subtitle: PropTypes.string,
    onClick: PropTypes.func
};
